/* eslint-disable @typescript-eslint/no-magic-numbers */
import Score1Gif from '../../images/level1.gif';
import Score2Gif from '../../images/level2.gif';
import Score3Gif from '../../images/level3.gif';
import Score4Gif from '../../images/level4.gif';
import Score5Gif from '../../images/level5.gif';
import Score1Grey from '../../images/level1-grey.png';
import Score2Grey from '../../images/level2-grey.png';
import Score3Grey from '../../images/level3-grey.png';
import Score4Grey from '../../images/level4-grey.png';
import Score5Grey from '../../images/level5-grey.png';
import Score1Light from '../../images/level1-light.png';
import Score2Light from '../../images/level2-light.png';
import Score3Light from '../../images/level3-light.png';
import Score4Light from '../../images/level4-light.png';
import Score5Light from '../../images/level5-light.png';

export enum ScoreLevels {
    Level1 = 1,
    Level2 = 2,
    Level3 = 3,
    Level4 = 4,
    Level5 = 5,
}

export const ScoreMap = {
    [ScoreLevels.Level1]: {
        gif: Score1Gif,
        light: Score1Light,
        grey: Score1Grey,
        text: 'academy_rating_1',
    },
    [ScoreLevels.Level2]: {
        gif: Score2Gif,
        light: Score2Light,
        grey: Score2Grey,
        text: 'academy_rating_2',
    },
    [ScoreLevels.Level3]: {
        gif: Score3Gif,
        light: Score3Light,
        grey: Score3Grey,
        text: 'academy_rating_3',
    },
    [ScoreLevels.Level4]: {
        gif: Score4Gif,
        light: Score4Light,
        grey: Score4Grey,
        text: 'academy_rating_4',
    },
    [ScoreLevels.Level5]: {
        gif: Score5Gif,
        light: Score5Light,
        grey: Score5Grey,
        text: 'academy_rating_5',
    },
};

export const PopupTitleMap = {
    [ScoreLevels.Level1]: 'academy_rating_1_title',
    [ScoreLevels.Level2]: 'academy_rating_1_title',
    [ScoreLevels.Level3]: 'academy_rating_1_title',
    [ScoreLevels.Level4]: 'academy_rating_2_title',
    [ScoreLevels.Level5]: 'academy_rating_3_title',
};

export const OtherTextMap = {
    [ScoreLevels.Level1]: 'academy_rating_1_title',
    [ScoreLevels.Level2]: 'academy_rating_1_title',
    [ScoreLevels.Level3]: 'academy_rating_1_title',
    [ScoreLevels.Level4]: 'academy_rating_2_title',
    [ScoreLevels.Level5]: 'academy_rating_3_title',
};

export const OtherTitleMap = {
    [ScoreLevels.Level1]: 'academy_rating_1_reason_6',
    [ScoreLevels.Level2]: 'academy_rating_1_reason_6',
    [ScoreLevels.Level3]: 'academy_rating_1_reason_6',
    [ScoreLevels.Level4]: 'academy_rating_2_reason_5',
    [ScoreLevels.Level5]: 'academy_rating_3_reason_5',
};
